import React from 'react'
export const applySetiToFilters = ({ filters, handleOnlyFilter, noTranslate = false, showCount = false }) => {
  return filters.map((filter) => {
    let secondaryTextStyle = { bold: true, color: 'success.base', height: 'auto' }
    if (filter?.isCheapest !== undefined && !filter?.isCheapest) {
      secondaryTextStyle = { bold: true, color: 'text.base', height: 'auto' }
    }

    let primaryLabel = filter?.primaryLabel

    if (showCount && filter?.count) {
      primaryLabel = `${primaryLabel} (${filter?.count})`
    }

    return {
      ...filter,
      primaryLabel: noTranslation(filter?.value, primaryLabel, noTranslate),
      hasOnlyFilter: false,
      hasOnlyFilterText: 'Only',
      handleOnlyFilter,
      secondaryTextStyle: secondaryTextStyle,
    }
  })
}

const noTranslation = (value, primaryLabel, noTranslate) => {
  return noTranslate ? (
    <>
      <span translate='no'>{value}</span>
      {primaryLabel?.slice(3)}
    </>
  ) : (
    primaryLabel
  )
}

export const getAttributeFilterUsageCopy = (tripType) => {
  let flightTypeText = ''
  if (tripType === 'RT') {
    flightTypeText = 'round-trip '
  }
  if (tripType === 'MT') {
    flightTypeText = 'multi-destination '
  }
  return `Select what's important to you, and we will only show ${flightTypeText}flights with those included.`
}

export const getFilterId = (type, index, value) => `${type}-filter-chip-index: ${index} value: ${value}`

export const reloadPage = (location = globalThis.window.location) => {
  const { pathname, search, hash } = location
  if (pathname.indexOf('/filter') > -1) {
    const listingsPath = pathname.replace(/\/filter$/, '/')
    location.replace(`${listingsPath}${search}${hash}`)
  } else {
    location.reload()
  }
}

export const getStaticFiltersForDynamicApi = ({ latestFilterState }) => {
  const {
    airlineCodes,
    originAirportCodes,
    destAirportCodes,
    numStops,
    arrivalTimeOptions,
    departTimeOptions,
    attributes,
  } = latestFilterState

  const filterDisabledItems = (items) =>
    items?.filter(({ disabled }) => !disabled).map(({ value }) => value) || []
  const mapTimeOptions = (options) =>
    options?.filter(({ disable }) => !disable).map(({ label }) => label) || []

  return {
    airlineCodes: filterDisabledItems(airlineCodes),
    originAirportCodes: filterDisabledItems(originAirportCodes),
    destAirportCodes: filterDisabledItems(destAirportCodes),
    numStops:
      numStops
        ?.filter(({ disabled }) => !disabled)
        .map(({ value }) => (value === '0' || value === '1' ? value : null))
        .filter(Boolean) || [],
    arrivalTimeOptions: mapTimeOptions(arrivalTimeOptions),
    departTimeOptions: mapTimeOptions(departTimeOptions),
    attributes: filterDisabledItems(attributes),
  }
}
